// extracted by mini-css-extract-plugin
export default {"body":"Skills_body__xQxTk","fade-in":"Skills_fade-in__ZruSD","items":"Skills_items__zbYjI"};